
<div>
  <b-row>
    <b-col lg="8">
      <Card icon="calendar-alt" :label="__('activities.details')">
        <template #actions>
          <b-button
            v-can:activities.update
            size="md"
            variant="primary"
            @click="openUpdateActivityModal"
          >
            <Icon icon="edit" size="14" class="mr-2"/>
            {{ __('buttons.edit') }}
          </b-button>
        </template>

        <DataGroup>
          <DataGroupItem :label="__('common.subject')" :value="activity.subject"/>
        </DataGroup>

        <b-row class="mb-4">
          <DataGroup class="col-4 pt-4 pl-3 pr-5 inline-data-group">
            <DataGroupItem :label="__('common.type')">
              <Badge variant="soft-primary">
                <Icon :icon="activity.typeData().icon" size="12" class="mr-2"/>
                {{ activity.typeData().label }}
              </Badge>
            </DataGroupItem>
          </DataGroup>

          <DataGroup class="col-4 pt-4 pl-3 pr-5 inline-data-group">
            <DataGroupItem :label="__('common.status')">
              <Badge :variant="activity.statusData().badge">
                {{ activity.statusData().label }}
              </Badge>
            </DataGroupItem>
          </DataGroup>

          <DataGroup class="col-4 pt-4 pl-3 inline-data-group">
            <DataGroupItem :label="__('common.priority')">
              <Badge :variant="activity.priorityData().badge">
                {{ activity.priorityData().label }}
              </Badge>
            </DataGroupItem>
          </DataGroup>
        </b-row>

        <DataGroup>
          <DataGroupItem :label="__('common.description')" :value="activity.description"/>
        </DataGroup>
      </Card>
    </b-col>

    <b-col lg="4">
      <Card icon="clock" :label="__('activities.dates-responsibles')">
        <DataGroup>
          <DataGroupItem :label="__('activities.form-activity-date')" :value="activity.activityDate"/>
          <DataGroupItem :label="__('common.entity')" :value="activity.entity.name"/>
          <DataGroupItem :label="__('common.responsible')" :value="activity.user.name"/>

          <DateField
            v-model="activity.reminderDate"
            show-time
            name="reminder_date"
            :description="__('activities.reminder')"
            class="mt-3 mb-3"
            :readonly="activity.isCompleted()"
          />

          <hr class="mt-1 mb-3"/>

          <b-button
            v-if="! activity.isCompleted()"
            v-can:activities.update
            size="sm"
            variant="primary"
            @click="updateReminder"
          >
            <Icon icon="clock" size="14" class="mr-2"/>
            {{ __('activities.button-update-reminder') }}
          </b-button>
        </DataGroup>
      </Card>
    </b-col>

    <b-col lg="8">
      <Card icon="comment" :label="__('activities.updates')" class="updates-card">
        <b-row>
          <TextAreaField
            v-model="note"
            class="col-12"
            name="note"
            :placeholder="__('activities.updates-note')"
          />

          <b-col cols="12">
            <b-button
              v-if="activity.canClose"
              v-can:activities.update
              size="sm"
              class="mr-2"
              variant="info"
              @click="update"
            >
              <Icon icon="check" size="14" class="mr-2"/>
              {{ __('buttons.update') }}
            </b-button>

            <b-button
              v-if="activity.canClose"
              v-can:activities.update
              size="sm"
              class="mr-2"
              variant="outline-info"
              @click="complete"
            >
              <Icon icon="check-circle" size="14" class="mr-2"/>
              {{ __('buttons.complete') }}
            </b-button>

            <b-button
              v-if="activity.canClose"
              v-can:activities.create
              size="sm"
              variant="outline-info"
              @click="completeAndNew"
            >
              <Icon icon="check-circle" size="14" class="mr-2"/>
              {{ __('activities.button-complete-new') }}
            </b-button>

            <b-button
              v-if="activity.canReactivate"
              v-can:activities.update
              size="sm"
              variant="outline-info"
              @click="reactivate"
            >
              <Icon icon="corner-up-left" size="14" class="mr-2"/>
              {{ __('activities.button-reactivate') }}
            </b-button>
          </b-col>
        </b-row>

        <template v-if="activity.notes.length" #footer>
          <p v-for="(item, key) in activity.notes" :key="key">
            <span>{{ item.note }}</span>
            <span class="small d-block">
              <i>
                {{ item.timestamp }}, {{ item.user.name }}
              </i>
            </span>
          </p>
        </template>
      </Card>
    </b-col>
  </b-row>
  <b-col>
    <b-row align-h="end">
      <b-col cols="auto">
        <b-button size="sm" variant="outline-primary" @click="closeModal">
          <Icon icon="times" class="mr-2" size="14" />
          {{ __('buttons.cancel') }}
        </b-button>
      </b-col>
    </b-row>
  </b-col>
</div>
